<template>
  <div class="root">
    <div v-for="(msg, inx) in text" :key="inx" class="message-container" :class="{ 'message-avatar': !sent }">
      <div v-if="sent" class="message-items-seed" style="align-self:flex-end">
        <div class="content">
          <span v-if="!msg.ask" v-html="msg.content" />
        </div>
      </div>

      <div v-if="!sent && ((questiontype >= 2 && questiontype <= 6) || !questiontype || questiontype === 11)" class="message-items message-items-inline">
        <div class="content">
          <div class="question">
            <p v-html="msg.content" />
            <!-- <div class="tip" v-if="questiontype && questiontype!==2 && !msg.optionclose">（请选择下面选项）</div> -->
          </div>
        </div>
      </div>
      <Avata v-if="!msg.report_content && !msg.isbq && !sent && (questiontype === 1 || questiontype === 7)" img="https://qiniu.laway.cn/fc096e7c51fa11e9ab49525400436b39.png" />
      <div class="message-items-content">
        <div v-if="!msg.report_content && !msg.isbq && !sent && (questiontype === 1 || questiontype === 7)" class="message-items message-items--nobg">
          <div class="message-items-inner">
            <div v-if="msg.qid" class="hts hair-bottom">
              法律意见
            </div>
            <div class="content">
              <span v-if="msg.content" v-html="msg.content" />
              <span v-else>对不起，这个问题我还没有学会，暂时没法答复您。</span>
            </div>
            <div class="message-items-inner__wrap">
              <div v-if="msg.qid" class="is-help">
                <div class="icon">
                  <a href="javascript:void(0)" :class="{ current: is_rate[0] && is_rate[1] == 1 }" @click="isHelp(msg, 1)">
                    <i class="icon-lp icon-elephant-lp-like" />
                  </a>
                  <a href="javascript:void(0)" :class="{ current: is_rate[0] && is_rate[1] == -1 }" @click="isHelp(msg, -1)">
                    <i class="icon-lp icon-elephant-lp-dislike" />
                  </a>
                </div>
              </div>

              <div v-if="!msg.ask && msg.related && msg.related.length" class="rel-list">
                <div v-if="msg.related && msg.related.length && msg.type === 1" class="ht">
                  通过分析或许您想问下列问题：
                </div>
                <ul class="list">
                  <li v-for="(rel, index) in msg.related" :key="index">
                    <a href="javascript:void(0)" @click="sendmsg(rel)">
                      {{ rel.content }}</a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- <div class="foot clearfix"
                 v-if="!msg.ask && questiontype!==7 && (msg.law.list.length || msg.case.list.length || msg.wj.length)">
              <a href="javascript:void(0)"
                 v-if="msg.law && msg.law.list.length"
                 @click="toggleTab(0, $event)">
                <i class="icon-elephant-law"></i> 法律依据</a>
              <a href="javascript:void(0)"
                 v-if="msg.case && msg.case.list.length"
                 @click="toggleTab(1, $event)">
                <i class="icon-elephant-case"></i> 相似案例</a>
              <a href="javascript:void(0)"
                 v-if="msg.wj && msg.wj.length"
                 @click="toggleTab(2, $event)">
                <i class="icon-elephant-file"></i> 文书模版</a>
            </div> -->
          </div>
          <div v-if="!msg.ask && questiontype !== 7 && (msg.law.list.length || msg.case.list.length || msg.wj.length)" class="message-foot clearfix">
            <a v-if="msg.law && msg.law.list.length" href="javascript:void(0)" @click="toggleTab(0, $event)">
              <i class="icon-lp icon-elephant-lp-law" /> 法律依据</a>
            <a v-if="msg.case && msg.case.list.length" href="javascript:void(0)" @click="toggleTab(1, $event)">
              <i class="icon-lp icon-elephant-lp-case" />相似案例</a>
            <!-- <a href="javascript:void(0)"
               v-if="msg.wj && msg.wj.length"
               @click="toggleTab(2, $event)">
              <i class="icon-elephant-file"></i> 文书模版</a> -->
          </div>
        </div>

        <div v-if="msg.law && msg.law.list.length && tab_selected == 0" class="message-items">
          <div class="hts hair-bottom">
            法律依据
          </div>
          <ul class="list-icon2 list-law">
            <li v-for="(la, index) in msg.law.list" :key="index" class="hair-bottom">
              <a href="javascript:void(0)" @click="toggle($event, la)">
                <span class="icon-dots">•</span>
                {{ la.parent_title }}</a>
              <div v-show="la.show" class="content" v-html="la.content" />
            </li>
          </ul>
        </div>

        <div v-if="msg.case && msg.case.list.length && tab_selected == 1" class="message-items">
          <div class="hts hair-bottom">
            相似案例
          </div>
          <ul class="list-icon2">
            <li v-for="(ca, index) in msg.case.list" :key="index" class="hair-bottom">
              <a href="javascript:void(0)" @click="showCase(ca.id)">
                <span class="icon-dots">•</span>
                {{ ca.title }}</a>
            </li>
          </ul>
        </div>

        <div v-if="!msg.report_content && !msg.isbq && !msg.ask && msg.wj && msg.wj.length && tab_selected == 2" class="message-items">
          <div v-if="msg.wj && msg.wj.length" class="hts hair-bottom">
            涉及到的文书模版
          </div>
          <ul class="list-icon2 list-file">
            <li v-for="(w, index) in msg.wj" :key="index" class="hair-bottom">
              <a :href="'https://xiaoxiangs.laway.cn' + w.url"><img src="/static/img/icon/icon-file.png"> {{ w.name }}</a>
            </li>
          </ul>
        </div>

        <div v-if="questiontype === 7 && msg.report_content" class="message-items">
          <div class="hts hair-bottom">
            法律详细分析意见
          </div>
          <div class="content" v-html="msg.content" />
          <div class="operate hair-top">
            <a href="javascript:void(0)" class="btn btn-warning" @click="showReport(msg)">
              <i class="icon-elephant-reports" /> 查看详细分析意见
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="stylus" scoped>
.list-file
  a
    display flex
    white-space normal
.list-law
  li
    .content
      padding 0 0.15rem 0.15rem 0
      font-size 0.2rem
      color #666
      line-height 1.4
      display none
    &.active
      a
        white-space normal
      .content
        display block
</style>
<script>
import Avata from './Avatar'
import Base64 from './js/base64.js'
import request from './js/request'

export default {
  name: 'ChatTest',
  components: {
    Avata
  },
  props: {
    sent: Boolean,
    label: String,
    bgColor: String,
    textColor: String,
    name: String,
    avatar: String,
    text: Array,
    stamp: String,
    size: String,
    questiontype: Number,
    ask: Object
  },
  data () {
    return {
      test: true,
      tab_selected: -1,
      is_rate: [false, 0]
    }
  },
  computed: {
    is_check_option () {
      return JSON.stringify(this.ask.item) !== '{}'
    }
  },
  mounted () {
    let self = this
    // const h = document.getElementById('container').clientHeight
    const h = document.documentElement.clientHeight - 160 || document.body.clientHeight - 160
    var obj = document.getElementsByClassName('baike')
    for (let i = 0; i < obj.length; i++) {
      obj[i].onclick = function () {
        // console.log(obj[i].getBoundingClientRect())
        // console.log($(obj[i])) //eslint-disable-line
        // console.log(obj[i].offsetLeft, obj[i].offsetTop)
        // 获取元素距离屏幕数值
        const rect = obj[i].getBoundingClientRect()
        // 判断弹出层如果在屏幕的3分之一之上，则向下弹出，否则向上弹出
        const type = rect.top - 160 < h / 3 // true为下 false为上
        // 判断向上向下返回不同的top值
        const top = !type ? obj[i].offsetTop - 20 : obj[i].offsetTop + 44 //eslint-disable-line
        const pos = { top, left: obj[i].offsetLeft }
        // alert(Base64.decode(this.getAttribute('content')))
        self.$emit('openPopover', {
          pos,
          type,
          show: true,
          content: Base64.decode(this.getAttribute('content')),
          title: this.innerHTML
        })
      }
    }
    console.log('ask:')
    console.log(this.ask)
  },
  methods: {
    showCase (id) {
      const num = (this.scroll_top = document.querySelector(
        '#container'
      ).scrollTop)
      this.$emit('setScrollTop', num)
      // this.$emit('recordScrollTop')
      this.$emit('getCase', id)
      // if (!this.$root.show_head) {
      //   this.$emit('getCase', id)
      // } else {
      //   this.$router.push(`/case/${id}`)
      // }
    },
    showReport (msg) {
      this.$emit('recordScrollTop')
      let reports = {
        content: msg,
        current: 0,
        show: true
      }
      this.$router.push({ name: 'Report', params: { reports: reports } })
    },
    choose () {
      this.test = false
    },
    toggle (e, la) {
      const dom = e.target.parentNode
      dom.classList.toggle('active')
      la.show = !la.show
    },
    toggleTab (index, event) {
      this.tab_selected = index
      console.log(event.target.parentNode)
      if (event.target === event.currentTarget) {
        // console.log($(event.target).parent().offset().top) //eslint-disable-line
        this.$emit('scrollControll', 'top', event.target.parentNode.offsetTop)
        // this.$emit('scrollControll', 'top', $(event.target).parent().offset().top) //eslint-disable-line
      }
    },
    setMoreContent (msg) {
      this.$emit('setContent', msg)
    },
    sendmsg (msg) {
      console.log('oid', msg, msg.content, msg.id)
      this.$emit('sendmsg', msg.content, msg.id)
    },
    sendoption (title, msg) {
      msg.optionclose = true
      this.$emit('sendoption', title)
    },
    getOption (type, title, index) {
      if (this.ask.item[index]) {
        this.$delete(this.ask.item, index)
      } else {
        this.ask.item = Object.assign({}, this.ask.item, { [index]: title })
      }
    },
    sendoptions (msg) {
      // const option = JSON.stringify(this.check_option)
      if (!this.is_check_option) {
        return
      }
      msg.optionclose = true
      this.$emit('sendoptions', this.ask.item)
    },
    async isHelp (msg, help) {
      console.log(msg.qid)
      if (msg.assess) {
        this.$message({
          message: '已评价',
          type: 'success'
        });
        return
      }
      msg.assess = 1
      const { data } = await request({
        url: 'https://xiaoxiangs.laway.cn/answer/rate/?wid=16',
        params: {
          qid: msg.qid,
          rate: help,
          wid: 16
        },
        method: 'get'
      })
      const text = data.errorcode ? '已评价' : '评价成功'
      this.is_rate = [true, help]
      this.$message({
        message: text,
        type: 'success'
      });
    }
  }
}
</script>
